module.exports = __webpack_public_path__ + "img/contest-19.29543fbf.png";